<template><span class="ai-status" :class="`is-${normalized}`"><i />{{ label }}</span></template>
<script>
export default {
  props: { status: { type: [String, Boolean], default: 'inactive' } },
  computed: {
    normalized() { const value = String(this.status).toLowerCase(); return ['active','success','finalized'].includes(value) ? 'active' : ['failed','blocked','inactive','revoked'].includes(value) ? 'danger' : 'warning' },
    label() { return typeof this.status === 'boolean' ? (this.status ? 'Active' : 'Inactive') : String(this.status).replace('_', ' ') }
  }
}
</script>

